import React from 'react';
import './ProspectCard.css';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';
import { ScoutingReport } from './ScoutingReport';
var moment = require('moment');

export class ProspectCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.selectedPlayer.stats,
      columns: this.playerStatsColumns,
      stats: true,
      scout: false,
      rank: false,
      pageSize: this.props.selectedPlayer.stats.length
    };
    this.saveReport = this.saveReport.bind(this);
  }

  playerStatsColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.seasonyear,
      minWidth: 80
    },
    {
      Header: 'League',
      id: 'league',
      accessor: d => d.league,
      minWidth: 70
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.team,
      minWidth: 70
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.gp,
      minWidth: 40
    },
    {
      Header: 'G',
      id: 'g',
      accessor: d => d.g,
      minWidth: 40
    },
    {
      Header: 'A',
      id: 'assists',
      accessor: d => d.a,
      minWidth: 40
    },
    {
      Header: 'P',
      id: 'points',
      accessor: d => d.p,
      minWidth: 40
    },
    {
      Header: '+/-',
      id: 'pm',
      accessor: d => d.pm,
      minWidth: 40
    }
  ];
  goalieStatsColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.seasonyear,
      minWidth: 80
    },
    {
      Header: 'League',
      id: 'league',
      accessor: d => d.league,
      minWidth: 70
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.team,
      minWidth: 70
    },
    {
      Header: 'GP',
      id: 'gp',
      accessor: d => d.gp,
      minWidth: 40
    },
    {
      Header: 'GAA',
      id: 'gaa',
      accessor: d => d.gaa,
      minWidth: 40
    },
    {
      Header: 'SV%',
      id: 'sv_pct',
      accessor: d => d.svp,
      minWidth: 40
    }
  ];

  rankingColumns = [
    {
      Header: 'ISS',
      id: 'iss',
      accessor: d => d.iss,
      minWidth: 40
    },
    {
      Header: "McKeen's",
      id: 'mckeens',
      accessor: d => d.mckeens,
      minWidth: 40
    },
    {
      Header: 'Prospect',
      id: 'hockeyProspect',
      accessor: d => d.hockeyProspect,
      minWidth: 40
    },
    {
      Header: 'NHL NA',
      id: 'nhlCentralNA',
      accessor: d => d.nhlCentralNA,
      minWidth: 40
    },
    {
      Header: 'NHL EU',
      id: 'nhlCentralEU',
      accessor: d => d.nhlCentralEU,
      minWidth: 40
    },
    {
      Header: 'Future',
      id: 'futureConsiderations',
      accessor: d => d.futureConsiderations,
      minWidth: 40
    }
  ];

  changeColumns(e) {
    if (e == 'rank') {
      console.log(Array(this.props.selectedPlayer.rankings));
      this.setState({
        columns: this.rankingColumns,
        data: Array(this.props.selectedPlayer.rankings),
        pageSize: 7,
        stats: false,
        rank: true,
        scout: false
      });
      document.getElementById('stat').classList.remove('active');
      document.getElementById('rank').classList.add('active');
    } else if (e == 'stat') {
      if (this.props.selectedPlayer.biographical.position == 'G') {
        this.setState({
          columns: this.goalieStatsColumns,
          data: this.props.selectedPlayer.stats,
          stats: true,
          rank: false,
          scout: false,
          pageSize: this.props.selectedPlayer.stats.length
        });
        if (document.getElementById('stat')) {
          document.getElementById('stat').classList.add('active');
          document.getElementById('rank').classList.remove('active');
        }
      } else {
        this.setState({
          columns: this.playerStatsColumns,
          data: this.props.selectedPlayer.stats,
          stats: true,
          rank: false,
          scout: false,
          pageSize: this.props.selectedPlayer.stats.length
        });
        if (document.getElementById('stat')) {
          document.getElementById('stat').classList.add('active');
          document.getElementById('rank').classList.remove('active');
        }
      }
    } else if (e == 'scout') {
      this.setState({ stats: false, rank: false, scout: true });
    } else if (e == 'ex') {
    }
  }

  componentDidUpdate() {
    if (
      this.props.selectedPlayer.stats != this.state.data &&
      this.state.stats
    ) {
      this.changeColumns('stat');
    }
  }

  saveReport() {
    let newReport = {
      report: {
        player_id: this.props.selectedPlayer.playerID,
        skating: +document.getElementById('reportSkating').value,
        sense: +document.getElementById('reportSense').value,
        puck_skills: +document.getElementById('reportPuck').value,
        compete: +document.getElementById('reportCompete').value,
        character: +document.getElementById('reportCharacter').value,
        physical_projection: +document.getElementById('reportPhysical').value,
        comments: document.getElementById('reportComments').value
      }
    };
    console.log(newReport, JSON.stringify(newReport));
    axios
      .post(apiServerUrl + '/save_scouting_report', newReport, requestOptions())
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div
        class="prospect-card"
        style={{
          outline: 'none',
          alignItems: 'baseline',
          overflowY: 'auto',
          maxHeight: '40em'
        }}
      >
        <div
          style={{
            display: 'flex',
            flex: 2,
            justifyContent: 'stretch',
            alignItems: 'stretch'
          }}
        >
          <div className="prospect-card-profile">
            <div className="prospect-card-profile-header">
              <span>PROSPECT CARD</span>
            </div>
            <div
              className="prospect-card-profile-content"
              style={{
                borderRight: '1px solid #61696e',
                padding: '1em',
                flex: 2,
                justifyContent: 'space-between'
              }}
            >
              <div class="prospect-bio">
                <div style={{ flex: 1 }}>
                  <img
                    src={this.props.selectedPlayer.biographical.imageUrl}
                    alt="Smiley face"
                    width="120"
                    height="120"
                    display="flex"
                  />
                </div>
                <div class="info">
                  <h4 class="player-name">
                    {this.props.selectedPlayer.biographical.firstName +
                      ' ' +
                      this.props.selectedPlayer.biographical.lastName}
                  </h4>
                  <div class="first-stats">
                    <div class="first-stats-data">
                      {this.props.selectedPlayer.biographical.position}
                    </div>
                    <div class="first-stats-data">
                      {this.props.selectedPlayer.biographical.height.replace(
                        / /g,
                        ''
                      )}
                    </div>
                    <div class="first-stats-data">
                      {this.props.selectedPlayer.biographical.weight}
                      lbs
                    </div>
                    <div class="first-stats-data" style={{ border: 'none' }}>
                      {this.props.selectedPlayer.biographical.currentAge}
                      yo
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', marginBottom: '1em' }}>
                    {/*)<img src="https://tsnimages.tsn.ca/ImageProvider/TeamLogo?seoId=vegas-golden-knights&width=84&height=84" alt="Smiley face" width="30" height="30" display="flex"></img>*/}
                    <span style={{ fontSize: '1.2em' }}>
                      <strong>
                        {this.props.selectedPlayer.biographical.currentTeam}
                      </strong>
                    </span>
                    <br />
                    <strong>
                      {this.props.selectedPlayer.biographical.currentLeague}
                    </strong>
                  </div>
                </div>
              </div>
              <div>
                <div className="second-stats">
                  <div className="second-stats-col">
                    <div>
                      <strong>Born:</strong>{' '}
                      <span style={{ color: 'rgb(100,128,144)' }}>
                        {moment(
                          this.props.selectedPlayer.biographical.dateOfBirth
                        ).format('MMM Do YYYY')}
                      </span>
                    </div>
                    <div>
                      <strong>ISS Ranking:</strong>{' '}
                      <span style={{ color: 'rgb(100,128,144)' }}>
                        {this.props.selectedPlayer.rankings.iss}
                      </span>
                    </div>
                    <div>
                      <strong>Mckeen's Ranking:</strong>{' '}
                      <span style={{ color: 'rgb(100,128,144)' }}>
                        {this.props.selectedPlayer.rankings.mckeens}
                      </span>
                    </div>
                  </div>
                  <div className="second-stats-col">
                    <div>
                      <strong>Birthplace:</strong>{' '}
                      <span style={{ color: 'rgb(100,128,144)' }}>
                        {this.props.selectedPlayer.biographical.birthCity},{' '}
                        {this.props.selectedPlayer.biographical.birthCountry}
                      </span>
                    </div>
                    <div>
                      <strong>Shoots:</strong>{' '}
                      <span style={{ color: 'rgb(100,128,144)' }}>
                        {this.props.selectedPlayer.biographical.handedness}
                      </span>
                    </div>
                    <div>
                      <button
                        onClick={this.props.modifyDraftList}
                        style={{
                          backgroundColor: 'rgb(56,88,110)',
                          border: 'none',
                          color: 'white',
                          padding: '0.3em 0.3em',
                          width: '100%',
                          borderRadius: '3px',
                          boxShadow: 'inset 0px -12px 20px 0px #233642'
                        }}
                      >
                        Add to Draft List
                      </button>
                    </div>
                    {/* background-color: rgb(56, 88, 110);border: none;color: white;padding: 0.3em 4em;border-radius: 3px;box-shadow: inset 0px -12px 20px 0px #141f26; */}
                  </div>
                </div>
              </div>
              <div class="listButtons" style={{ textAlign: 'center' }} />
            </div>
          </div>
          {(this.state.stats || this.state.rank) && (
            <div
              class="prospect-card-data"
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <div
                style={{ display: 'flex', flexDirection: 'column', flex: 3 }}
              >
                <table className="prospect-table-headers">
                  <tbody>
                    <tr>
                      <th
                        id="stat"
                        className={'active'}
                        onClick={e => this.changeColumns('stat')}
                      >
                        Stats
                      </th>
                      <th id="rank" onClick={e => this.changeColumns('rank')}>
                        Rankings
                      </th>
                      <th id="scout" onClick={e => this.changeColumns('scout')}>
                        Scouting Report
                      </th>
                      {/*<th id="ex" onClick={(e) => this.changeColumns("ex")}>Expand</th>*/}
                    </tr>
                  </tbody>
                </table>
                <ReactTable
                  data={this.state.data}
                  filterable={false}
                  showPagination={false}
                  resizable={false}
                  defaultSortDesc={true}
                  defaultSorted={[{ id: 'season', desc: true }]}
                  ref="prospectCardTable"
                  columns={this.state.columns}
                  pageSize={this.state.pageSize}
                  className="-striped -highlight"
                />
              </div>
            </div>
          )}
          {this.state.scout &&
            !this.props.selectedPlayerScouting && (
              <div
                style={{
                  display: 'flex',
                  flex: 2,
                  flexDirection: 'column',
                  justifyContent: 'baseline',
                  alignItems: 'stretch'
                }}
              >
                <div className="prospect-card-profile-header">
                  <span
                    className="backToStats"
                    onClick={e => this.changeColumns('stat')}
                  >
                    Back to Stats
                  </span>
                </div>
                <div
                  style={{
                    fontSize: '20px',
                    justifyContent: 'center',
                    padding: '2em'
                  }}
                >
                  <span>
                    No scouting reports for{' '}
                    {this.props.selectedPlayer.biographical.firstName +
                      ' ' +
                      this.props.selectedPlayer.biographical.lastName}
                  </span>
                </div>
                <div
                  style={{
                    margin: '1em',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <div
                    className="reportButton"
                    onClick={e =>
                      (document.getElementById('newReport').style.display =
                        'initial')
                    }
                  >
                    <span>Write New Report</span>
                  </div>
                  <div id="newReport" style={{ display: 'none' }}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Skating"
                        className="reportInput"
                        id="reportSkating"
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Hockey Sense"
                        className="reportInput"
                        id="reportSense"
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Puck Skills"
                        className="reportInput"
                        id="reportPuck"
                      />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Character"
                        className="reportInput"
                        id="reportCharacter"
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Compete"
                        className="reportInput"
                        id="reportCompete"
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        step="0.25"
                        placeholder="Physical Projection"
                        className="reportInput"
                        id="reportPhysical"
                      />
                    </div>
                    <textarea
                      rows="5"
                      cols="60"
                      placeholder="Write new scouting report"
                      id="reportComments"
                    />
                    <input
                      type="submit"
                      value="Save"
                      style={{ width: '20%' }}
                      onClick={this.saveReport}
                    />
                  </div>
                </div>
              </div>
            )}

          {this.state.scout &&
            this.props.selectedPlayerScouting && (
              <div
                style={{
                  display: 'flex',
                  flex: 2,
                  flexDirection: 'column',
                  justifyContent: 'baseline',
                  alignItems: 'stretch'
                }}
              >
                <div className="prospect-card-profile-header">
                  <span
                    className="backToStats"
                    onClick={e => this.changeColumns('stat')}
                  >
                    Back to Stats
                  </span>
                </div>
                <ScoutingReport
                  selectedPlayer={this.props.selectedPlayer}
                  selectedPlayerScouting={this.props.selectedPlayerScouting}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ProspectCard.js